// The one way to book a demo: BossDrop's own booking calendar (Oct 28 2026;
// replaces Calendly). Every "Book a demo" opens it over the page
// (components/booking/BookingOverlay.js), with open times from Eric's own
// calendar. The link itself points at /book-a-demo, the same calendar as a
// page, so a new tab, an old link or an email still lands on it.

export const BOOKING_PATH = "/book-a-demo";
export const OPEN_BOOKING_EVENT = "bd:open-booking";

// Counted as intent, not as a lead: the lead is the booking itself.
export function trackDemoClick() {
  try {
    window.gtag?.("event", "book_demo_click");
    window.fbq?.("trackCustom", "BookDemoClick");
  } catch {}
}

// A plain click opens the calendar over the page. A click that asks for a
// new tab or window (a modifier key, a middle click) follows the link.
export function openBooking(e) {
  trackDemoClick();
  if (e && (e.defaultPrevented || e.button > 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey)) return;
  e?.preventDefault?.();
  window.dispatchEvent(new CustomEvent(OPEN_BOOKING_EVENT));
}

// Spread on an <a>.
export const DEMO_LINK = Object.freeze({
  href: BOOKING_PATH,
  onClick: openBooking,
});
